import { useIsFetching } from '@tanstack/react-query'
import { Outlet, useParams } from 'react-router'
import { Loader2 } from 'lucide-react'
import { ProveedorMunicipio } from '@/sesion/MunicipioActual'
import { buscarMunicipio } from '@/sesion/permisos'
import { useSesion } from '@/sesion/useSesion'
import SinAccesoMunicipio from '@/paginas/SinAccesoMunicipio'

/**
 * El municipio activo va en la URL, igual que en la API. Aca se comprueba que
 * sea uno de los del usuario antes de montar el panel.
 *
 * Si no lo es, no se muestra un 404 generico: se dice que no tienes acceso a
 * ese municipio y se ofrece el selector. La API responde 404 a proposito para
 * no confirmar que el slug existe; esa decision es del servidor, y esta
 * pantalla solo habla de los municipios que el usuario ya tiene.
 */
export default function MunicipioProtegido() {
  const { municipio: slug } = useParams()
  const { sesion } = useSesion()
  const refrescando = useIsFetching({ queryKey: ['auth', 'yo'] }) > 0

  const municipio = buscarMunicipio(sesion?.municipios, slug)

  if (municipio === null) {
    // Puede que la lista de municipios este vieja: se espera a auth/yo.
    if (refrescando) {
      return (
        <div className="flex min-h-dvh items-center justify-center gap-2 text-muted-foreground" aria-busy="true">
          <Loader2 className="size-4 animate-spin" aria-hidden="true" />
          Cargando tu municipio…
        </div>
      )
    }

    return <SinAccesoMunicipio slug={slug ?? ''} />
  }

  return (
    <ProveedorMunicipio value={municipio}>
      <Outlet />
    </ProveedorMunicipio>
  )
}
